import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { AssigneeOption } from '@user/store/salesTeam'

export function useBacksideHandlers() {
  const { setFieldValue } = useFormikContext<{
    salesTeamIds: number[]
    assigneeIds: string[]
    numDays?: number
  }>()

  const getId = useCallback((option: AssigneeOption) => {
    return String(option.id)
  }, [])
  const renderSummary = useCallback((options, text: string) => {
    if (options.length === 1) {
      return options[0].label || options[0].name
    } else {
      return `${options.length} ${text}`
    }
  }, [])

  const handleSelectOwnerId = useCallback(
    (owners) => {
      setFieldValue(
        'assigneeIds',
        owners.map((owner) => owner.id),
      )
    },
    [setFieldValue],
  )

  const isOptionEqual = useCallback(
    (optionA: AssigneeOption, optionB: AssigneeOption) =>
      optionA.id === optionB.id,
    [],
  )

  return {
    renderSummary,
    handleSelectOwnerId,
    isOptionEqual,
    getId,
  }
}
